import { z } from 'zod';
import { PapelMembro } from './enums.js';
import { Id } from './comum.js';

export const Senha = z.string().min(8).max(200)
  .refine((s) => /[a-zA-Z]/.test(s) && /\d/.test(s), 'a senha precisa ter letra e número');

export const LoginBody = z.object({
  email: z.email().max(200),
  senha: z.string().min(1).max(200),
});
export type LoginBody = z.infer<typeof LoginBody>;

export const SetupBody = z.object({
  escritorio: z.string().trim().min(2).max(120),
  nome: z.string().trim().min(2).max(120),
  email: z.email().max(200),
  senha: Senha,
});
export type SetupBody = z.infer<typeof SetupBody>;

export const EscritorioResumo = z.object({ id: Id, nome: z.string(), papel: PapelMembro, membroId: Id, exigirEntregaParaConcluir: z.boolean(), /** o escritório exige a verificação em duas etapas de todo membro */ exigir2fa: z.boolean().optional(), /** este membro só enxerga a própria carteira de clientes */ carteira: z.boolean().optional(), /** período de teste deste escritório termina nesta data (AAAA-MM-DD) */ testeAte: z.string().nullable().optional() });
export type EscritorioResumo = z.infer<typeof EscritorioResumo>;

/** Uma sessão aberta do usuário (o id é só um pedaço do identificador: serve para apontar qual encerrar). */
export const SessaoAtiva = z.object({ id: z.string(), atual: z.boolean(), navegador: z.string(), ip: z.string().nullable(), criadoEm: z.string(), ultimoUsoEm: z.string() });
export type SessaoAtiva = z.infer<typeof SessaoAtiva>;

export const Eu = z.object({
  id: Id,
  nome: z.string(),
  email: z.string(),
  escritorio: EscritorioResumo.nullable(),
  escritorios: z.array(EscritorioResumo),
  totpAtivo: z.boolean(),
  /** o escritório ativo exige duas etapas e este usuário ainda não ligou: a API só libera a configuração */
  precisaConfigurar2fa: z.boolean().optional(),
  /** administra a plataforma (todos os escritórios) */
  superAdmin: z.boolean().optional(),
  /** escritórios de que a pessoa faz parte mas que não abrem: suspenso pela plataforma ou teste vencido */
  bloqueios: z.array(z.object({ escritorio: z.string(), motivo: z.enum(['SUSPENSO', 'TESTE_VENCIDO']) })).optional(),
  /** versão dos termos que este usuário ainda precisa aceitar (null = em dia) */
  termosPendentes: z.object({ versao: z.string(), comoAdministrador: z.boolean() }).nullable().optional(),
});

export const AceitarTermosBody = z.object({ versao: z.string().max(20) });
export type Eu = z.infer<typeof Eu>;

export const TrocarEscritorioBody = z.object({ escritorioId: Id });
export const TrocarSenhaBody = z.object({ atual: z.string().min(1), nova: Senha });
